import React from "react";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import { ImageResizable } from "../components/elements/ImageResizeable";
import { isMobile } from "react-device-detect";
import { useTranslation } from "react-i18next";

dayjs.extend(relativeTime);

export const TinyTripReview = ({ userReview, displayType = "small" }) => {
    const { t } = useTranslation();

    if (!userReview) return null;

    const timeAgo = dayjs(userReview?.review_date).fromNow();

    // Outer container styles
    const outerStyle =
        displayType === "big"
            ? {
                position: "absolute",
                marginRight: "0.7rem",
                zIndex: 100,
                maxWidth: "50%",
                top: 0,
                maxHeight: "4.7rem",
                marginTop: isMobile ? "11.8rem" : "11.1rem"
            }
            : undefined; // small uses tailwind defaults

    // Inner element sizes
    const imgClass =
        displayType === "big"
            ? "tw-h-9 tw-w-9 tw-rounded-full tw-border-2 tw-border-white tw-object-cover"
            : "tw-h-7 tw-w-7 tw-rounded-full tw-border-2 tw-border-white tw-object-cover";

    const textSize = displayType === "big" ? (isMobile ? "11px" : "11px") : (isMobile ? "10px" : "12px");
    const timeSize = displayType === "big" ? (isMobile ? "10px" : "10px") : (isMobile ? "9px" : "11px");

    return (
        <div
            style={outerStyle}
            className="tw-absolute tw-bottom-[9px] tw-right-1 tw-z-10 tw-flex tw-max-w-[90%] tw-items-center tw-gap-2 tw-rounded-xl tw-border tw-border-gray-100 tw-bg-white/60 tw-px-2.5 tw-py-2 tw-shadow-md tw-backdrop-blur-sm tw-transition-all tw-duration-300 after:tw-absolute after:tw-bottom-[-8px] after:tw-right-3 after:tw-border-[4px] after:tw-border-transparent after:tw-border-r-white/60 after:tw-border-t-white/60"
        >
            <div className="tw-relative">
                <ImageResizable src={userReview?.user_image} size="xs" className={imgClass} />
            </div>

            <div className="tw-min-w-0 tw-flex-1">
                <div
                    style={{ fontSize: textSize }}
                    className="tw-flex tw-items-baseline tw-justify-end tw-gap-1"
                >
                    <span className="tw-text-gray-700 tw-line-clamp-3 tw-text-right">
                        {t("user_review_message", {
                            defaultValue: userReview?.positive,
                        })}
                    </span>
                </div>

                {!timeAgo.includes("months") && (
                    <div className="tw-mt-0.5 tw-flex tw-items-center tw-justify-end tw-gap-2">
                        <span style={{ fontSize: timeSize }} className="tw-text-gray-500">
                            {timeAgo}
                        </span>
                    </div>
                )}
            </div>
        </div>
    );
};
